@use '../../../common/styles/variables' as *;
@use '../../../common/mixins/buttons' as *;

:host {
  display: block;
  @include default-css-variables;
  width: inherit;
}

.nylas-disable-emails {
  border: 1px solid var(--nylas-base-200);
  border-radius: var(--nylas-border-radius-2x);
  margin: 1rem;
  color: var(--nylas-base-900);
}

.header {
  padding: 1rem;
  display: grid;
  grid-template-columns: 1fr auto;
  border-bottom: 1px solid var(--nylas-base-200);

  h3 {
    border-radius: var(--nylas-border-radius-2x);
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    color: var(--nylas-base-900);
    text-align: left;
  }

  p {
    display: flex;
    gap: 4px;
    align-items: center;
    margin: 0.25rem 0 0 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 20px;
    color: var(--nylas-base-600);
    text-align: left;
  }

  .drawer-toggle {
    display: flex;
    gap: 24px;
    align-items: center;

    .chevron {
      display: flex;
      align-self: center;
      cursor: pointer;

      &:hover,
      &:active {
        color: var(--nylas-primary);
      }

      &.open {
        transform: rotate(90deg);
      }

      &.closed {
        transform: rotate(270deg);
      }

      &.disabled {
        cursor: not-allowed;
        color: var(--nylas-base-300);

        &:hover {
          color: var(--nylas-base-300);
        }
      }
    }
  }
}

.content {
  background-color: var(--nylas-base-25);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;

  label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  toggle-switch {
    margin-right: 12px;
  }
  select-dropdown {
    width: auto;
  }
}
